<section class="sg-cononSubmitainer sg-add-section-dialog" >
    <div class="row m-0 border-bottom p-3">
       <h1 mat-dialog-title class="mb-0 pl-2">{{modalHeaderTitle}}</h1>
      <!--<h1 mat-dialog-title class="mb-0 pl-2" *ngIf="data.isEdit">Edit Section</h1>  -->
    </div>
    <main mat-dialog-content class="sg-dialog-content py-3 pl-4">
      <form [formGroup]="solarForm" novalidate autocomplete="off">
        <div class="row">
          <div class="col-2 pt-2 pr-0">
            <label class="sg-form-field-label"> Form #</label>
            <span class="sg-form-field-required-marker ml-1">*</span>
          </div>
          <div class="col-9 pl-4">
            <mat-form-field appearance="outline" class="w-50 sg-validation">
              <input matInput type="number" formControlName="form" (keyup)="formExistsValidation($event.target.value)">
              <mat-error *ngIf="solarForm.controls.form.errors?.required">
                This is required Field
              </mat-error>
              <mat-error class="error-font-size" *ngIf="solarForm.controls['form'].hasError('inFormExists')">
                The Form has already been added.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
            <div class="col-2 pt-2 pr-0">
              <label class="sg-form-field-label">Name</label>
              <span class="sg-form-field-required-marker ml-1"
                          matTooltip="Date where this item will start showing in the Home Page"
                          matTooltipClass="sg-tooltip-userdialog">*</span>
            </div>
            <div class="col-9 pl-4">
              <mat-form-field appearance="outline" class="w-50 sg-validation">
                <input matInput type="text" formControlName="name">
                <mat-error *ngIf="solarForm.controls.name.errors?.required">
                  This is required Field
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-2 pt-2 pr-0">
              <label class="sg-form-field-label">Category</label>
              <span class="sg-form-field-required-marker ml-1"
                          matTooltip="Date where this item will start showing in the Home Page"
                          matTooltipClass="sg-tooltip-userdialog">*</span>
            </div>
            <div class="col-9 pl-4">
              <mat-form-field appearance="outline" class="w-50 sg-validation">
                <input matInput type="text" formControlName="category">
                <mat-error *ngIf="solarForm.controls.category.errors?.required">
                  This is required Field
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        <div class="row">
          <div class="col-2 pt-2 pr-0">
            <label class="sg-form-field-label">Description</label>
          </div>
          <div class="col-9 pl-4">
            <mat-form-field appearance="outline" class="w-100 sg-validation">
              <textarea matInput type="text" rows="10" cols="50" formControlName="description"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-2 pr-0">
            <label class="sg-form-field-label">Document</label>
            <span class="sg-form-field-required-marker ml-1">*</span>
          </div>
          <div class="col-10 pl-4 d-flex">
            <span class="sg-primary-text mat-primary mr-2" *ngIf="isEdit">{{filePath[1]}}</span>
            <input type="file" name="Browse" class="sg-read-more" (change)="onFileSelected($event)" formControlName="document">
          </div>
        </div>
        <div class="row" *ngIf="isExtensionNotValid">
          <div class="offset-4 col-8 pl-4 d-flex">
            <mat-error>
              The file extension is not allowed.
            </mat-error>
          </div>
        </div>
        <div class="row ml-0 pl-0" *ngIf="isEdit">
            <div class="col-4 pl-0">
              <mat-checkbox class="my-2" formControlName="isActive">Is Active?
                <span class="sg-infoicon icon-position">
                  <p class="material-icons-outlined" [tooltip]="template5" contentType="template"
                      [options]="tooltipOptions" tooltipClass="automated-form-tooltip-feedback">help_outline
                  </p>
                  <ng-template #template5 class="w-100">
                      <div class="row mx-0 w-100">
                          <div class="col-12 w-100 px-0">
                              <span> When unchecked, form will not be visible.
                              </span>
                          </div>
                      </div>
                  </ng-template>
              </span>
              </mat-checkbox>
            </div>
        </div>
      </form> 
     </main>
    <div class="border-top row mx-0 justify-content-end" mat-dialog-actions>
      <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4" 
      [disabled]="isEdit ? !solarForm.dirty || solarForm.invalid : solarForm.invalid"   
      (click)="onSaveClick()" type="button"
       >Save</button>
      <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button" type="button"
       (click)="onCancelClick()">Cancel</button>
    </div>
  </section>
  <div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
  </div>
 